/**
 * Merges two props objects. Defined values from `overrideProps` take
 * precedence over `defaultProps`. Skips undefined values in both.
 *
 * props priority: `overrideProps` > `defaultProps`
 */
const resolveProps = <T extends Record<string, unknown>>(
  defaultProps: Partial<T> | null | undefined,
  overrideProps: Partial<T>,
): Partial<T> => {
  if (!defaultProps) return overrideProps;

  const result: Record<string, unknown> = {};

  for (const key in defaultProps) {
    if (defaultProps[key] !== undefined) {
      result[key] = defaultProps[key];
    }
  }

  for (const key in overrideProps) {
    if (overrideProps[key] !== undefined) {
      result[key] = overrideProps[key];
    }
  }

  return result as Partial<T>;
};

export default resolveProps;
